export default __webpack_public_path__ + "fa86a7289eb146a3599bb0f3e9ca482b.svg";